// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".K_4fbmITOFOOAX_DpJPg{display:block;width:100%;margin-top:.25rem;font-size:.875em;color:#dc3545}", "",{"version":3,"sources":["webpack://./src/shared/components/form/form.css"],"names":[],"mappings":"AAAA,sBACI,aAAA,CACA,UAAA,CACA,iBAAA,CACA,gBAAA,CACA,aAAA","sourcesContent":[".invalidFeedback {\n    display: block;\n    width: 100%;\n    margin-top: 0.25rem;\n    font-size: 0.875em;\n    color: #dc3545;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"invalidFeedback": "K_4fbmITOFOOAX_DpJPg"
};
export default ___CSS_LOADER_EXPORT___;
